import { AppAction } from 'types/app';
import { FEATURE_FLAGS_LOADED } from 'constants/reduxActions';

export type FeaturesState = {
  [key: string]: string | number | boolean;
};

const initialState = {};

export default function featuresReducer(state: Readonly<FeaturesState> = initialState, action: AppAction): FeaturesState {
  switch (action.type) {
    case FEATURE_FLAGS_LOADED:
      return {
        ...state,
        ...action.payload.features
      };
    default:
      return state;
  }
}
